import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Youtube, X } from 'lucide-react'

const YouTubeBanner = () => {
  const [searchParams] = useSearchParams()
  const [isVisible, setIsVisible] = useState(false)
  const fromYouTube = searchParams.get('from') === 'youtube'
  const prefectureId = searchParams.get('prefecture')
  const teamId = searchParams.get('team')
  const highlight = searchParams.get('highlight')

  useEffect(() => {
    if (fromYouTube) {
      setIsVisible(true)
      // Google Analyticsイベント送信
      if (typeof window !== 'undefined' && (window as any).gtag) {
        ;(window as any).gtag('event', 'youtube_visit', {
          prefecture_id: prefectureId,
          team_id: teamId,
          highlight: highlight,
        })
      }
    }
  }, [fromYouTube, prefectureId, teamId, highlight])

  if (!isVisible || !fromYouTube) return null

  const getMessage = () => {
    if (prefectureId) {
      return '動画で紹介した都道府県のデータを確認できます'
    }
    if (teamId) {
      return '動画で紹介したチームのデータを確認できます'
    }
    return '動画で紹介したデータの詳細はこちらから確認できます'
  }

  return (
    <div className="bg-gradient-to-r from-red-500 to-red-600 text-white p-4 rounded-lg mb-6 shadow-lg animate-in slide-in-from-top duration-300">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 p-2 bg-white/20 rounded-lg">
          <Youtube className="h-6 w-6" />
        </div>
        <div className="flex-1">
          <h3 className="font-bold text-lg mb-1">YouTubeからご訪問ありがとうございます！</h3>
          <p className="text-sm text-red-50 mb-2">{getMessage()}</p>
          <div className="flex items-center gap-2 text-xs text-red-100">
            <span>💡 ヒント:</span>
            <span>左のフィルターから都道府県やチームを選択して、詳細データを確認できます</span>
          </div>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className="flex-shrink-0 p-1 hover:bg-white/20 rounded transition-colors"
          aria-label="閉じる"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  )
}

export default YouTubeBanner

